import React from "react";
import "./StatsCard.css";

const TONE_STYLES = {
  blue: {
    iconBg: "#DBEAFE",
    iconColor: "#2563EB",
  },
  green: {
    iconBg: "#DCFCE7",
    iconColor: "#22C55E",
  },
  amber: {
    iconBg: "#FEF3C7",
    iconColor: "#F59E0B",
  },
  purple: {
    iconBg: "#F3E8FF",
    iconColor: "#A855F7",
  },
  red: {
    iconBg: "#FEE2E2",
    iconColor: "#EF4444",
  },
  cyan: {
    iconBg: "#CFFAFE",
    iconColor: "#06B6D4",
  },
};

export default function StatsCard({ title, value, icon, tone = "blue" }) {
  const toneStyle = TONE_STYLES[tone] || TONE_STYLES.blue;
  const Icon = icon;

  return (
    <div className="stats-card-row">
      <div
        className="stats-card-row-icon"
        style={{
          backgroundColor: toneStyle.iconBg,
          color: toneStyle.iconColor,
        }}
      >
        {Icon ? <Icon sx={{ fontSize: 20 }} /> : null}
      </div>

      <div className="stats-card-row-content">
        <div className="stats-card-row-title">{title}</div>
        <div className="stats-card-row-value">{value}</div>
      </div>
    </div>
  );
}